import { useCallback, useState } from 'react';

import { useTracking } from '@change-corgi/core/react/tracking';

import type { WaypointCallbackArgs } from 'src/app/shared/components/layout/lazy';

import type { Props } from '../../index';
import { useTipSharingButton } from '../useTipSharingButton';

export const VIEW_TRACKING_EVENT = 'petition_manage_online_community_recommendations_view';

type UseRecommendationsResult = ModelHookResult<
	undefined,
	{
		handleTipClick: () => Promise<void>;
		trackView: (
			args: WaypointCallbackArgs,
			facebookSource: string | null | undefined,
			redditSource: string | null | undefined,
			viewContext: Props['viewContext'],
		) => void;
	}
>;

export function useRecommendations(): UseRecommendationsResult {
	const [tracked, setTracked] = useState(false);
	const {
		actions: { handleTipClick },
	} = useTipSharingButton();
	const track = useTracking();

	const trackView = useCallback(
		(
			{ currentPosition }: WaypointCallbackArgs,
			facebookSource: string | null | undefined,
			redditSource: string | null | undefined,
			viewContext: Props['viewContext'],
		) => {
			if (tracked || currentPosition === 'below') {
				return;
			}
			void track(VIEW_TRACKING_EVENT, {
				context: 'petition_dashboard_group_rec',
				view_context: viewContext,
				fb_recommendation_source: facebookSource,
				reddit_recommendation_source: redditSource,
			});
			setTracked(true);
		},
		[tracked, track, setTracked],
	);

	return {
		actions: {
			handleTipClick,
			trackView,
		},
	};
}
